import { render } from "./Statistique.vue?vue&type=template&id=6bc53ec1&scoped=true&ts=true"
import script from "./Statistique.vue?vue&type=script&lang=ts"
export * from "./Statistique.vue?vue&type=script&lang=ts"

import "./Statistique.vue?vue&type=style&index=0&id=6bc53ec1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc53ec1"]])

export default __exports__